import Resource from '@/api/Resource';
import TaskFile from '@/models/TaskFile';
import TaskStatus from '@/models/TaskStatus';
import User from '@/models/User';
import { markdownToHtml } from '@/helpers/string';

export default class extends Resource {
  $name = 'task-messages';

  $defaults() {
    return {
      id: null,
      task_id: 0,
      user_id: 0,
      new_status_id: 0,
      message: '',
      created_at: null,
      files: null,

      // TODO: Сделать автоматическое заполнение связей
      // user: { model: User },
      // status: { model: TaskStatus },
      // files: { collection: TaskFile },
    };
  }

  $fill({ user, new_status, files }) {
    if (user) {
      this.user = new User(user);
    }
    if (new_status) {
      this.new_status = new TaskStatus(new_status);
    }
    if (files) {
      this.files = TaskFile.collection(files);
    }
  }

  get messageHtml() {
    if (!this._messageHtml) {
      this._messageHtml = markdownToHtml(this.message);
    }
    return this._messageHtml;
  }
}
